import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField,
    ISearchRequestSubset, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Set_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_SET_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Set WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: { maxLength: 50}},
    SET_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Set Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 10}},
    SET_TYPE:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Type', columnResourceName: 'colType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    SET_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}}
}

var SetSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_SET_ID',
        id_ui: 'SET_ID',
        name:  'SET_NAME'},


    searchProviderFields: vUI_Set_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Sets_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }
}


var SetSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "SETSSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'SET_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'SET_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'SET_ID','SET_NAME','SET_TYPE'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SetSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var SetSearch: ISearch = {
    searchName: "Find Set",
    renderOptions: { ui5ResourceId: "SetSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SetSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("SetBO", "Set", SetSearch, "Set Search")

export {SetSearch}